import { ButtonProps } from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { DropdownMenuItemProps } from '@virtus/components/DropdownMenu/DropdownMenu.model';
import { colors } from '@virtus/components/theme';
import styled from 'styled-components';
import DropdownMenu, { DropdownMenuItem } from '@virtus/components/DropdownMenu';

export interface WidgetContainerProps {
  title: string;
  subtitle?: string;
  headerButtons?: React.ReactElement<ButtonProps> | Array<React.ReactElement<ButtonProps>>;
  /** extra `<DropdownMenuItem>` in dropdown menu in container */
  menu?: React.ReactElement<DropdownMenuItemProps> | Array<React.ReactElement<DropdownMenuItemProps>>;
  onRemove: () => void;
  children?: React.ReactNode;
}

class WidgetContainer extends React.Component<WidgetContainerProps> {
  renderActionMenu = () => {
    const { headerButtons, menu, onRemove } = this.props;
    return (
      <ActionWrapper>
        {headerButtons}
        <DropdownMenu data-testid="WidgetContainer-menu">
          {menu}
          <DropdownMenuItem key="Remove Widget" onClick={onRemove}>
            <CloseIcon />
            Remove Widget
          </DropdownMenuItem>
        </DropdownMenu>
      </ActionWrapper>
    );
  };

  render() {
    const { title, subtitle } = this.props;

    return (
      <StyledCard square>
        <StyledCardHeader
          title={title}
          classes={{ title: 'title' }}
          subheader={subtitle}
          action={this.renderActionMenu()}
        />
        <StyledCardContent>{this.props.children}</StyledCardContent>
      </StyledCard>
    );
  }
}

const StyledCard = styled(Card)`
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-top: 8px solid ${colors.accent};
  border-radius: 0 0 4px 4px;
  background-color: ${colors.bgLight};
`;

const StyledCardHeader = styled(CardHeader)`
  padding-top: 14px;
  padding-bottom: initial;
  align-items: flex-start;
  & .title {
    font-size: 20px;
    font-weight: 500;
    text-transform: uppercase;
  }
`;

const StyledCardContent = styled(CardContent)`
  padding: 0;
`;

const ActionWrapper = styled.div`
  display: flex;
`;

export default WidgetContainer;
